import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { motion } from 'framer-motion'
import { fadeIn } from '../../variants';

const HomeRow3 = () => {
  const navigate = useNavigate();

  const handleNavigation = (value) => {
    navigate(value);
  };

  return (
    <div className='home-row3-container'>
      <div className='column1'>
        <motion.div
          variants={fadeIn("right", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-title' style={{ color: '#F2F2F2', height: 'clamp(38px, 8vw, 88px)', fontSize: 'clamp(40px, 8vw, 96px)' }}
        >
          ABOUT US
        </motion.div>
        <motion.div
          variants={fadeIn("right", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='description' style={{ color: '#FFFFFF', width: '71%', fontSize: 'clamp(16px, 2.3vw, 24px)' }}
        >
          With over 5 years of experience in the iGaming industry, 101 White Label has empowered 50+ partners to launch
          successful iGaming projects. We offer comprehensive White Label, Gaming API, and Turnkey solutions, ensuring
          seamless integration, rapid deployment, and optimized performance.
        </motion.div>
        <Button id='action-button' onClick={() => handleNavigation('/about-us')} sx={{ maxWidth: '184px' }}>
          View more
        </Button>
      </div>
      <div className='column2'>
        <motion.div
          variants={fadeIn("left", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-title' style={{ color: '#F2F2F2', height: 'clamp(38px, 8vw, 88px)', fontSize: 'clamp(40px, 8vw, 96px)' }}>
          WHY CHOOSE US
        </motion.div>
        <motion.div
          variants={fadeIn("left", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='description' style={{ color: '#FFFFFF', width: '71%', fontSize: 'clamp(16px, 2.3vw, 24px)' }}>
          We are passionate about developing better gaming solutions that enable the ultimate entertainment experience. Work with us!
          <br />
          Build your website with us!
        </motion.div>
        <Button id='action-button' onClick={() => handleNavigation('/get-started')} sx={{ maxWidth: '184px' }}>
          Get started
        </Button>
      </div>
    </div>
  );
};

export default HomeRow3;